import React, { useEffect, useState } from 'react';
import ModalFormFuelTypes from '../../components/forms/catalog/modal.form.fuelTypes';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListFuelType() {
  const [msgGet ,setMsgGet] = useState('');
  const [FuelTypes,setFuelTypes] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getfuelType()
  }, []);

  const createFuelType = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getfuelType()
  };

  const getfuelType = async()=>{
    const responsefuelTypes = await get('/catalog/fueltype/',{})
    if(responsefuelTypes.success){
      setFuelTypes(responsefuelTypes.data);
    }else{
      setMsgGet(responsefuelTypes.message)
    }       
  }

  const editButton = (row) => {
    return (
      <ModalFormFuelTypes
        title="Modificar Combustible"
        button_text="Editar"
        button_variant="outline-primary"
        fuelTypeSelect={row.id}
        callback={createFuelType}
      ></ModalFormFuelTypes>
    );
  };

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormFuelTypes
        title="Crear Combustible"
        button_text="Crear Combustible"
        button_variant="primary"
        callback={createFuelType}
      ></ModalFormFuelTypes>
      <ListTables
        data={FuelTypes}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListFuelType;
